export enum TwilioCallStatus {
    QUEUED = "queued",
    RINGING = "ringing",
    IN_PROGRESS = "in-progress",
    COMPLETED = "completed",
    BUSY = "busy",
    FAILED = "failed",
    NO_ANSWER = "no-answer",
    CANCELED = "canceled",
    INITIATED = "initiated",
}

// String literal union for all Twilio statuses including alternative spellings
export type TwilioCallStatusType =
    | "queued"
    | "ringing"
    | "in-progress"
    | "completed"
    | "busy"
    | "failed"
    | "no-answer"
    | "no_answer"
    | "canceled"
    | "cancelled"
    | "initiated";

// Utility: Normalize Twilio status to the enum
export function normalizeTwilioStatus(status: string): TwilioCallStatus | undefined {
    switch (status) {
        case "no-answer":
        case "no_answer":
            return TwilioCallStatus.NO_ANSWER;
        case "canceled":
        case "cancelled":
            return TwilioCallStatus.CANCELED;
        case "queued":
            return TwilioCallStatus.QUEUED;
        case "ringing":
            return TwilioCallStatus.RINGING;
        case "in-progress":
            return TwilioCallStatus.IN_PROGRESS;
        case "completed":
            return TwilioCallStatus.COMPLETED;
        case "busy":
            return TwilioCallStatus.BUSY;
        case "failed":
            return TwilioCallStatus.FAILED;
        case "initiated":
            return TwilioCallStatus.INITIATED;
        default:
            return undefined;
    }
}
